import controller from './fillerbuster-controller';

const FillerbusterComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    token: '<',
    content: '<',
    fontName: '<',
    fontSizeMax: '<',
    fontSizeMin: '<',
  },
  template: `
    <div class="fb-container">
      <a
        ng-href="{{ ctrl.chartUrl }}"
        style="text-decoration: underline;"
        target="_blank"
        ng-if="ctrl.shouldAddLink">
        {{ctrl.content}}
      </a>
      <span class="fb-content" ng-if="!ctrl.shouldAddLink">
        {{ctrl.content}}
      </span>
    </div>`,
};

export { FillerbusterComponent };
